import { MeetingResponse } from '@app/models/meeting.model';

export const ACTIVE_MEETING_STATUSES = new Set<number>([1, 2, 3]); //New, Offered, Accepted
export const CLOSED_MEETING_STATUSES = new Set<number>([4, 5, 6, 7]); // Done, Rejected, Cancelled by Customer | Us

export function isActiveMeetingStatus(
  status: number | null | undefined
): boolean {
  return status != null && ACTIVE_MEETING_STATUSES.has(status);
}

export function getMeetingSortDate(meeting: MeetingResponse): string {
  return (
    meeting.acceptedDate ??
    meeting.offeredDate3 ??
    meeting.offeredDate2 ??
    meeting.offeredDate1 ??
    ''
  );
}

export function meetingPriority(meeting: MeetingResponse): number {
  switch (meeting.status) {
    case 3:
      return 3;
    case 2:
      return 2;
    case 1:
      return 1;
    default:
      return 0;
  }
}

export function getCurrentMeeting(
  meetings: MeetingResponse[],
  projectId: string
): MeetingResponse | null {
  const pid = projectId.trim().toLowerCase();
  if (!pid) return null;

  const actives = meetings
    .filter((meeting) => (meeting.projectId ?? '') === pid)
    .filter((meeting) => isActiveMeetingStatus(meeting.status));

  if (!actives.length) return null;

  actives.sort((a, b) => {
    const prioDiff = meetingPriority(b) - meetingPriority(a);
    if (prioDiff !== 0) return prioDiff;

    const da = getMeetingSortDate(a);
    const db = getMeetingSortDate(b);
    return db.localeCompare(da);
  });

  return actives[0] ?? null;
}

export function hasActiveMeetingForProject(
  meetings: MeetingResponse[],
  projectId: string
): boolean {
  const pid = projectId.trim().toLowerCase();
  if (!pid) return false;
  return meetings.some((m) => (m.projectId ?? '').toLowerCase() === pid);
}
